"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: payroll/deposit-switch.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fpayroll%2Fdeposit-switch.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositSwitchStatusToJSON = exports.depositSwitchStatusFromJSON = exports.depositSwitchProviderToJSON = exports.depositSwitchProviderFromJSON = exports.DepositAmount = exports.DepositSwitchStatus = exports.DepositSwitchProvider = void 0;
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.payroll.deposit.proto';
/**
 * Represents a provider used for direct deposit switching.
 */
var DepositSwitchProvider;
(function (DepositSwitchProvider) {
    DepositSwitchProvider["INVALID_PROVIDER"] = "INVALID_PROVIDER";
    DepositSwitchProvider["TRUV"] = "TRUV";
    DepositSwitchProvider["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DepositSwitchProvider || (exports.DepositSwitchProvider = DepositSwitchProvider = {}));
/**
 * The status of a direct deposit switch.
 */
var DepositSwitchStatus;
(function (DepositSwitchStatus) {
    DepositSwitchStatus["INVALID_DEPOSIT_SWITCH_STATUS"] = "INVALID_DEPOSIT_SWITCH_STATUS";
    DepositSwitchStatus["PENDING"] = "PENDING";
    DepositSwitchStatus["SUCCESS"] = "SUCCESS";
    DepositSwitchStatus["FAILED"] = "FAILED";
    DepositSwitchStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DepositSwitchStatus || (exports.DepositSwitchStatus = DepositSwitchStatus = {}));
function createBaseDepositAmount() {
    return { entireAmount: undefined, percentAmount: undefined, fixedAmount: undefined };
}
exports.DepositAmount = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.entireAmount)) {
            message.entireAmount = globalThis.Boolean(object.entireAmount);
        }
        if (isSet(object.percentAmount)) {
            message.percentAmount = globalThis.String(object.percentAmount);
        }
        if (isSet(object.fixedAmount)) {
            message.fixedAmount = amount_1.Amount.fromJSON(object.fixedAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.entireAmount !== undefined) {
            obj.entireAmount = message.entireAmount;
        }
        if (message.percentAmount !== undefined) {
            obj.percentAmount = message.percentAmount;
        }
        if (message.fixedAmount !== undefined) {
            obj.fixedAmount = amount_1.Amount.toJSON(message.fixedAmount);
        }
        return obj;
    },
    create(base) {
        return exports.DepositAmount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDepositAmount();
        message.entireAmount = object.entireAmount ?? undefined;
        message.percentAmount = object.percentAmount ?? undefined;
        message.fixedAmount = (object.fixedAmount !== undefined && object.fixedAmount !== null)
            ? amount_1.Amount.fromPartial(object.fixedAmount)
            : undefined;
        return message;
    },
};
function depositSwitchProviderFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PROVIDER':
            return DepositSwitchProvider.INVALID_PROVIDER;
        case 1:
        case 'TRUV':
            return DepositSwitchProvider.TRUV;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DepositSwitchProvider.UNRECOGNIZED;
    }
}
exports.depositSwitchProviderFromJSON = depositSwitchProviderFromJSON;
function depositSwitchProviderToJSON(object) {
    switch (object) {
        case DepositSwitchProvider.INVALID_PROVIDER:
            return 'INVALID_PROVIDER';
        case DepositSwitchProvider.TRUV:
            return 'TRUV';
        case DepositSwitchProvider.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.depositSwitchProviderToJSON = depositSwitchProviderToJSON;
function depositSwitchStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DEPOSIT_SWITCH_STATUS':
            return DepositSwitchStatus.INVALID_DEPOSIT_SWITCH_STATUS;
        case 1:
        case 'PENDING':
            return DepositSwitchStatus.PENDING;
        case 2:
        case 'SUCCESS':
            return DepositSwitchStatus.SUCCESS;
        case 3:
        case 'FAILED':
            return DepositSwitchStatus.FAILED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DepositSwitchStatus.UNRECOGNIZED;
    }
}
exports.depositSwitchStatusFromJSON = depositSwitchStatusFromJSON;
function depositSwitchStatusToJSON(object) {
    switch (object) {
        case DepositSwitchStatus.INVALID_DEPOSIT_SWITCH_STATUS:
            return 'INVALID_DEPOSIT_SWITCH_STATUS';
        case DepositSwitchStatus.PENDING:
            return 'PENDING';
        case DepositSwitchStatus.SUCCESS:
            return 'SUCCESS';
        case DepositSwitchStatus.FAILED:
            return 'FAILED';
        case DepositSwitchStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.depositSwitchStatusToJSON = depositSwitchStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=deposit-switch.js.map